import { render, staticRenderFns } from "./OpenOrCloseVerifyModal.vue?vue&type=template&id=fa97ec0e&scoped=true"
import script from "./OpenOrCloseVerifyModal.vue?vue&type=script&lang=js"
export * from "./OpenOrCloseVerifyModal.vue?vue&type=script&lang=js"
import style0 from "./OpenOrCloseVerifyModal.vue?vue&type=style&index=0&id=fa97ec0e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa97ec0e",
  null
  
)

export default component.exports